import { api } from '@/api'
import type { Workspace } from '@/types/models'

export const workspacesApi = {
  index: (): Promise<Workspace[]> =>
    api.get<{ data: Workspace[] }>('/api/workspaces').then((r) => r.data),

  store: (name: string): Promise<Workspace> =>
    api.post<{ data: Workspace }>('/api/workspaces', { name }).then((r) => r.data),

  update: (workspaceId: string, name: string): Promise<Workspace> =>
    api.put<{ data: Workspace }>(`/api/workspaces/${workspaceId}`, { name }).then((r) => r.data),

  /** Resolves the active workspace named by the `X-Workspace` header. */
  current: (workspaceId: string): Promise<Workspace> =>
    api
      .get<{ data: Workspace }>('/api/workspace', { 'X-Workspace': workspaceId })
      .then((r) => r.data),
}